/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { ISwapper, ISwapperInterface } from "../ISwapper";

const _abi = [
  {
    inputs: [],
    name: "spenderToApprove",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenIn",
        type: "address",
      },
      {
        internalType: "address",
        name: "_tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amountIn",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_priceProvider",
        type: "address",
      },
      {
        internalType: "address",
        name: "_siloAsset",
        type: "address",
      },
    ],
    name: "swapAmountIn",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenIn",
        type: "address",
      },
      {
        internalType: "address",
        name: "_tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amountOut",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_priceProvider",
        type: "address",
      },
      {
        internalType: "address",
        name: "_siloAsset",
        type: "address",
      },
    ],
    name: "swapAmountOut",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class ISwapper__factory {
  static readonly abi = _abi;
  static createInterface(): ISwapperInterface {
    return new utils.Interface(_abi) as ISwapperInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ISwapper {
    return new Contract(address, _abi, signerOrProvider) as ISwapper;
  }
}
